import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';

const CheckoutMeta = ({
    cityDisplayName,
    spot
}) => {
    const metaTitle = (spot && spot.meta_title && spot.meta_title.length > 0)
        ? spot.meta_title
        : (spot && spot.facility)
            ? `Reserve parking at ${spot.facility.street_address}, ${spot.facility.city}, ${spot.facility.state}`
            : null;
    const metaDescription = (spot && spot.meta_description && spot.meta_description.length > 0)
        ? spot.meta_description
        : (spot && spot.title)
            ? `Find ${spot.title} parking options. Use SpotHero to search for parking options in lots and garages ${(cityDisplayName && cityDisplayName.length > 0) ? `in ${cityDisplayName}'s` : 'at'} ${spot.title}`
            : null;
    const alternateUrl = (spot && spot.latitude && spot.longitude)
        ? `spothero://com.spothero/facility/?latitude=${spot.latitude}&longitude=${spot.longitude}`
        : null;
    const canonicalUrl = (spot && spot.canonical_url)
        ? spot.canonical_url
        : null;

    return (
        <Helmet>
            {/* eslint-disable react/jsx-max-props-per-line */}
            {metaTitle &&
                <title>{metaTitle}</title>
            }
            {metaDescription &&
                <meta name="description" itemProp="description" content={metaDescription} />
            }
            {alternateUrl &&
                <link rel="alternate" href={alternateUrl} />
            }
            {canonicalUrl &&
                <link rel="canonical" href={canonicalUrl} />
            }
            <meta name="robots" content="noindex, nofollow" />
            {/* eslint-enable react/jsx-max-props-per-line */}
        </Helmet>
    );
};

CheckoutMeta.propTypes = {
    cityDisplayName: PropTypes.string,
    spot: PropTypes.object
};

export default CheckoutMeta;
